import React, {PropsWithChildren} from "react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import type {IWidgetLoaderController} from "views/components/widget_loader/widget_loader.controller";
import {observer} from "mobx-react";
import {Bootstrap} from "views/components/bootstrap/bootstrap.component";
import {PagePreloader} from "views/components/preloader";

export const WidgetLoaderComponent: React.FC<PropsWithChildren> = observer(({children}) => {
	const controller = useViewController<IWidgetLoaderController>(Bindings.WidgetLoaderController);

	if (!controller.isReady) {
		return <PagePreloader />;
	}

	return <Bootstrap>{children}</Bootstrap>;
});
